<template>
  <div class="consulting">
    <TextPage>
      <div class="copy-header">
        <div class="inner-copy">
          <p class="knuvu-title">Consulting & Transactional Services</p>
          <p class="knuvu-subtitle">Strategy</p>
          <p>
            KnuVu, LLC is an evolution of brauning, LLC, a Mobile & Emerging Technologies strategy consulting boutique. brauning worked
            with all Tier 1 Carriers, Microsoft, Qualcomm, Network Equipment Providers such as Ericsson and Alcatel Lucent, and more
            than 20 startups and midcap firms. brauning differentiated itself from the larger more established consulting houses by
            building on a base of deep domain expertise and technical competency and working with clients on implementation.
          </p>
          <p>
            In our Strategy practice we leverage Subject Matter Experts (SMEs) to quickly prototype your KnuVu and then support
            with iterations and conclusions. Our transactional execution experience provides us the platform to be very direct
            with Strategic recommendations including optimal pricing structure and go-to-market initiatives.
          </p>
          <p>
            KnuVu principals have lead in category creation and innovation and we find that where other consultancies end at strategy
            and exploration, KnuVu boldly moves into implementation, deployment, and execution.
          </p>
          <p>
            We have worked with large caps and startups and although our core product is the same, we tailor our Strategy services
            and pricing models to each unique company and segment.
          </p>

          <p class="knuvu-subtitle">Applied Methodology</p>
          <p>
            KnuVu principals and team members will work with your strategy, corporate development, product, marketing, finance, and
            other team members to develop a company or department specific KnuVu. We call this our Applied Methodology practice and
            engagements typically last three weeks to three months depending on the level of complexity and size of teams involved.
          </p>

          <p class="knuvu-subtitle">Corporate Development</p>
          <p>
            KnuVu is by far the best tool on the market today for fit analysis on both buy side and sell side. We advise large cap
            companies on segment investments and candidate analysis including valuation and qualitative metrics. We are an outsourced
            Corporate Development service for Small Cap companies providing end-to-end accounting, legal, diligence, valuation,
            transactional structure, and execution support. We work with entrepreneurs and our client companies governance Boards to
            optimize total return by evaluating tax optimization, earn-out, and post-acquisition employment contracts.
          </p>

          <p class="knuvu-subtitle">Transactional Support</p>
          <p>
            KnuVu provides transactional support for first transactions or category creation.
            Our process includes engaging potential targets, obtaining feedback, iterating on messaging, collateral, product,
            and then templating first transactions.
          </p>
        </div>
      </div>
    </TextPage>
  </div>
</template>

<script>
import TextPage from "@/components/global/text-page.vue";
export default {
  name: "Consulting",
  title: "Consulting - Knuvu",
  components: {
    TextPage,
  },
};
</script>